module.exports = __webpack_public_path__ + "media/assets/increasing-a9bcb423545aba3c48f9486821712eaf.svg";